/* eslint-disable */
/* eslint-disable react/prop-types */
import { IconButton, withStyles } from '@material-ui/core';
import BusinessIcon from '@material-ui/icons/Business';
import React, { useContext, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import ServicesContext from '../../Contexts/Services/Services.context';
import filtersActionCreators from '../../State/Store/Filters/Filters.actions';
import getFiltersSelectedAccount from '../../State/Store/Filters/Selectors/FiltersSelectedAccount.selector';
import helpers from '../../Support/Text';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import AccountSwitcher from '../AccountSwitcher/AccountSwitcher.component';

/**
 * OrderAccountSwitcher
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const OrderAccountSwitcher = ({ actions, classes, currentAccount, accounts = [], isMobile }) => {
  const [accountSwitcherOpen, setAccountSwitcherOpen] = useState(false);
  const services = useContext(ServicesContext);
  // get billToAccounts array
  let billToAccounts = services.authService.getGroups() || [];

  // find names associated with each billToAccount
  billToAccounts = billToAccounts.map((billToAccount) => {
    const foundAccount = accounts.find((account) => {
      return helpers.getNumberFromBillTo(billToAccount) === account.CustomerCode.trim();
    });
    if (foundAccount) {
      return {
        accountName: foundAccount.AccountName,
        billTo: billToAccount,
      };
    }
    // no matching account name then as a backup display billTo number
    return {
      accountName: billToAccount,
      billTo: billToAccount,
    };
  });

  let switcher = null;
  if (isMobile) {
    switcher = (
      <React.Fragment>
        <IconButton aria-label="Columns" color="inherit" edge="start" onClick={() => setAccountSwitcherOpen(true)}>
          <BusinessIcon />
        </IconButton>
        <span className={classes.displayNone}>
          <AccountSwitcher
            accounts={billToAccounts}
            onChange={(value) => {
              actions.filtersSelectAccount(value);
            }}
            open={accountSwitcherOpen}
            onClose={() => setAccountSwitcherOpen(false)}
            value={currentAccount}
          />
        </span>
      </React.Fragment>
    );
  } else {
    switcher = (
      <AccountSwitcher
        accounts={billToAccounts}
        onChange={(value) => {
          actions.filtersSelectAccount(value);
        }}
        value={currentAccount}
      />
    );
  }
  return billToAccounts.length > 0 ? switcher : null;
};

export default compose(
  withStyles(themeCreateInjectableStyles({}), { withTheme: true }),
  connect(
    (state) => ({
      currentAccount: getFiltersSelectedAccount(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...filtersActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(OrderAccountSwitcher);
